export default __webpack_public_path__ + "static/media/google-drive.9120ed9e.svg";